import { NON_MOBILE_MIN_SCREEN_SIZE } from "theme/antd";

import useMediaQuery from "./useMediaQuery";

const useIsMobile = () => useMediaQuery(`(max-width: ${NON_MOBILE_MIN_SCREEN_SIZE}px)`);

export default useIsMobile;
